import React from 'react'
import {Row, Col, Input, Button,Modal,Form, Switch } from 'antd'

class CreateModal extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            status:false
        }
    }
    createAccount= (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                console.log(values)
                this.props.changeVisible(false,values);
                this.props.form.resetFields();
            }
        });
    }
    cancelCreateAccount(){
        this.props.form.resetFields();
        this.props.changeVisible(false,'');
    }


    render() {
        const {getFieldDecorator} = this.props.form;
        const data=this.props.detailData;

        return (
            <Modal
                    maskClosable={false}
                    destroyOnClose={true}
                    visible={this.props.visible}
                    title={"编辑标签"}
                    onOk={this.createAccount.bind(this)}
                    onCancel={this.cancelCreateAccount.bind(this)}
                    footer={[
                        <Button key="back" onClick={this.cancelCreateAccount.bind(this)}>
                        取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.createAccount.bind(this)}>
                        确定
                        </Button>,
                    ]}>
                    <Form>
                        <Row>
                            <Col span={24}>
                                <Form.Item
                                    label="标签名称"
                                    labelCol={{span: 4}} wrapperCol={{span: 19}}
                                    >
                                        {getFieldDecorator('name', {
                                            initialValue: data.name,
                                            rules: [{
                                                required: true, message: '请填写标签名称',
                                            }],
                                        })(
                                            <Input style={{width:'70%'}} size={'small'}/>
                                        )}
                                </Form.Item>
                                {
                                    
                                    data.type === "GUIDE"? 
                                    <Form.Item>
                                         {
                                             getFieldDecorator('status', {
                                                valuePropName: 'checked',
                                                initialValue:data.status === 1
                                             })(
                                                <Switch checkedChildren="显示" unCheckedChildren="隐藏"/>
                                             )
                                         }
                                    </Form.Item>
                                    :
                                    null
                                }
                            </Col>
                            
                        </Row>
                    </Form>
                    
                </Modal>    
        )
    }
}

export default Form.create({name: 'addTag'})(CreateModal);